const CLUSTERS_TABLE_READY = "clusters-table-ready"

const ADD_EDIT_CLUSTER_READY = "cluster-add-edit-ready"

const SEARCH_TEXT_STATE = "clusters-table-search-text-state"
const ROWS_PER_PAGE_STATE = "clusters-table-rows-per-page-state"
const PAGINATION_STATE = "clusters-table-pagination-state"

const CLUSTER_ID_FOR_ACTION = "clusters-table-cluster-id-for-action"


const initialState = {
    isClustersTableReady: true,
    isAddEditClusterReady: true,
    clusters: {},

    
    clusterSelectedId: null,
    
    previousSearchText: "",
    previousRowsPerPageValue: 15,
    previousPaginationValue: 1,
    
}


export default function reducer(state = initialState, action) {
    let duplicateState = null
    switch (action.type) {
        case CLUSTERS_TABLE_READY:
            return Object.assign({}, state, { isClustersTableReady: action.payload })
        case ADD_EDIT_CLUSTER_READY:
            return Object.assign({}, state, { isAddEditClusterReady: action.payload })
        
        case SEARCH_TEXT_STATE :
            duplicateState = Object.assign({}, state)
            duplicateState.previousSearchFieldText = action.payload
            return Object.assign({}, state, duplicateState)
        
        case ROWS_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)
        
        case PAGINATION_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)

        case CLUSTER_ID_FOR_ACTION:
            return Object.assign({}, state, {clusterSelectedId:action.payload})

        default:
        return state
    
    }

}

export function clusterTableReady(data) {
    return {
        type: CLUSTERS_TABLE_READY,
        payload: data
    }
}


export function addEditClusterReady(data) {
    return {
        type: ADD_EDIT_CLUSTER_READY,
        payload: data
    }
}


export function searchTextState(searchText){
    return {
        type:SEARCH_TEXT_STATE,
        payload:searchText
    }
}

export function rowsPerPageState(rows){
    return {
        type:ROWS_PER_PAGE_STATE,
        payload:rows
    }
}

export function paginationState(pageNo){
    return{
        type:PAGINATION_STATE,
        payload:pageNo
    }
}

export function clusterIdForAction(clusterId){
    return{
        type:CLUSTER_ID_FOR_ACTION,
        payload:clusterId
    }
}


// WEBPACK FOOTER //
// ./src/modules/Clusters/redux/clusters.js